import { inject, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CoreService } from '@/app/services/core.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-reenvio-justificacion',
    templateUrl: './reenvio-justificacion.component.html',
    styleUrls: ['./reenvio-justificacion.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReenvioJustificacionComponent {
  private spinner = inject(NgxSpinnerService);

  hasFinished: boolean = false;
  seReenvio: boolean = false;
  responseReenvio: boolean = false;
  isValid: boolean = false;
  reenvioRQ = {
    idCarga: '',
    idEstatus: '',
    justificacion: '',
  }

  constructor(
    private toastr: ToastrService,
    private router: Router,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<ReenvioJustificacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){

    let {idCarga, idEstatus, seReenvio, justificacion} = data;
    this.reenvioRQ.idCarga = idCarga;
    this.reenvioRQ.idEstatus = idEstatus; 

    this.reenvioRQ.justificacion = justificacion != null ? justificacion : '';
    this.seReenvio = seReenvio;
    if(!seReenvio && idEstatus === 'Entregado'){
      this.isValid = true;
    }
  }


  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas reenviar la carga?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => {
        if(result.value){
          this.enviarCarga();
        }
      });
    }
  }

  enviarCarga(){
    this.spinner.show();
    this.coreService.reenvioCarga(this.reenvioRQ).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Carga Reenviada.',
          'success'
        ).then(result=>{
          this.responseReenvio = true;
          this.hasFinished = true;
          this.onClose();
        });
      },
      error: (err) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  onClose(){
    if(!this.hasFinished && !this.seReenvio){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha hecho el reenvío de la carga. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      if(!this.seReenvio || this.responseReenvio){
        this.dialogRef.close({updateList: true, seReenvio: this.responseReenvio});
      }else{
        this.dialogRef.close({updateList: false});
      }
    }
  }
  
}
